// Service autonome de la case Commande x BCI (PRESTATAIRE, paniers importes).
// Le prestataire BCI a UNE seule action : envoyer son offre a l'acheteur en saisissant
// l'email de ce dernier. Route confirmee (V1 OffreBCI handleSubmit -> POST /bdci/{id}/envoyer
// avec { email } ; core api.php). Pas de signature/OTP, pas de chiffrage editable ici.
// Le chargement de la commande passe par commandeBCIService (services/entityService), cf.
// hooks/useCommandeData (GET /bdci/commande/{id} -> {status, data} + mapping `formulaire`).

const authedFetch = async <T = unknown>(path: string, options: RequestInit = {}): Promise<T> => {
  const token = localStorage.getItem('token');
  if (!token) throw new Error("Aucun token d'authentification trouvé");

  const response = await fetch(`${process.env.REACT_APP_API_URL}${path}`, {
    ...options,
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      Accept: 'application/json',
      ...(options.headers || {}),
    },
  });

  if (!response.ok) {
    const data = (await response.json().catch(() => ({}))) as { message?: string };
    throw new Error(data.message || `Erreur HTTP: ${response.status}`);
  }
  return response.json().catch(() => ({})) as Promise<T>;
};

// Envoyer l'offre a l'acheteur : POST /bdci/{id}/envoyer, corps { email } (email de l'acheteur).
export const envoyerOffre = (commandeId: number, email: string): Promise<unknown> =>
  authedFetch(`/bdci/${commandeId}/envoyer`, {
    method: 'POST',
    body: JSON.stringify({ email }),
  });
